import { Options } from "highcharts";

const DEFAULT_CHART_CONFIG: Options = {
  chart: {
    type: "column",
  },
  colors: ["#FF9B00", "#FF5858", "#3064E4", "#37CDCD", "#24B375", "#575BFF"],
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    series: {
      borderWidth: 0,
      dataLabels: {
        enabled: true,
      },
    },
  },
  title: undefined,
  xAxis: {
    type: "category",
  },
  yAxis: {
    allowDecimals: false,
    endOnTick: true,
    labels: {
      enabled: true,
    },
    maxPadding: 0.05,
    tickAmount: 5,
    title: undefined,
  },
};

export default DEFAULT_CHART_CONFIG;
